export const OBTENER_PRODUCTOS = 'OBTENER_PRODUCTOS';
export const OBTENER_PRODUCTO = 'OBTENER_PRODUCTO';
export const CREAR_PRODUCTO = "CREAR_PRODUCTO";
export const ADD_CART = "ADD_CART";
export const  OBTENER_CARRITO = "OBTENER_CARRITO";
export const REMOVE_CART = "REMOVE_CART";
export const OBTENER_ORDENES = "OBTENER_ORDENES";
export const OBTENER_ORDEN = "OBTENER_ORDEN";
export const CREAR_ORDENES = "CREAR_ORDENES";

export const CERRAR_SESION = 'CERRAR_SESION';
export const EDITAR_EXITOSO = 'EDITAR_EXITOSO';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_EXITOSO = 'LOGIN_EXITOSO';
export const OBTENER_USUARIOS = 'OBTENER_USUARIOS';
export const OBTENER_USUARIOS_ERROR = 'OBTENER_USUARIOS_ERROR';
export const OBTENER_CLIENTE = 'OBTENER_CLIENTE';
export const REGISTRO_ERROR = 'REGISTRO_ERROR';
export const REGISTRO_EXITOSO = 'REGISTRO_EXITOSO';
export const USUARIO_AUTENTICADO = 'USUARIO_AUTENTICADO';


export const ERROR = 'ERROR';

export const OCULTAR_ALERTA = 'OCULTAR_ALERTA';
export const MOSTRAR_ALERTA = 'MOSTRAR_ALERTA';
